import React, { useState } from "react";
import { deepCopy } from "../../utils";
import * as deviceService from "../deviceService";
import { showWarningToast } from "../../validation/ToastContainer";

function CheckConnectionSection({ modalData, passwordChanged, connected, setConnected, loading, setLoading, disabled }) {

    const [errorMessage, setErrorMessage] = useState('');
    const [load, setLoad] = useState(loading);

    const onButtonClick = async () => {
        setLoading(true);
        setLoad(true);
        setErrorMessage('');
        setConnected(null);
        const connectionConfig = deepCopy(modalData);

        if (passwordChanged) {
            delete connectionConfig.id;
        }

        const result = await deviceService.checkConnectivity(connectionConfig);
        //Added by Octopus DevTeam on Feb 28 2022
        if (result == null) {
            showWarningToast("Please Update The Required Passwords, then check connectivity again!");
            setLoading(false);
            setLoad(false);
        }
        else {
            if (result.connected) {
                setConnected(true);
                modalData.status = 'CONNECTED';
            } else {
                setConnected(false);
                setErrorMessage(result.output);
                modalData.status = 'DISCONNECTED';
            }
            setLoading(false);
            setLoad(false);
        }
    }


    const stateClass = load
        ? "is-testing"
        : connected === true
            ? "is-success"
            : connected === false
                ? "is-error"
                : "is-idle";

    return (
        <div className="modal-v2-step2-status-shell">
            <div className={`modal-v2-step2-indicator ${stateClass}`}>
                {load ? (
                    <>
                        <div className="modal-v2-step2-indicator-track">
                            <span className="modal-v2-step2-indicator-dot is-testing" />
                            <span className="modal-v2-step2-indicator-line is-testing" />
                            <span className="modal-v2-step2-indicator-loader">
                                <span className="modal-v2-step2-loader-ring" />
                            </span>
                            <span className="modal-v2-step2-indicator-line" />
                            <span className="modal-v2-step2-indicator-dot" />
                        </div>
                        <div className="modal-v2-step2-status-text is-testing">Testing Connection...</div>
                    </>
                ) : connected === true ? (
                    <>
                        <div className="modal-v2-step2-indicator-track">
                            <span className="modal-v2-step2-indicator-dot is-success" />
                            <span className="modal-v2-step2-indicator-line is-success" />
                            <span className="modal-v2-step2-indicator-result is-success">
                                <span className="modal-v2-step2-indicator-symbol">✓</span>
                            </span>
                            <span className="modal-v2-step2-indicator-line is-success" />
                            <span className="modal-v2-step2-indicator-dot is-success" />
                        </div>
                        <div className="modal-v2-step2-status-text is-success">Successfully Connected</div>
                    </>
                ) : connected === false ? (
                    <>
                        <div className="modal-v2-step2-indicator-track">
                            <span className="modal-v2-step2-indicator-dot is-error" />
                            <span className="modal-v2-step2-indicator-line is-error" />
                            <span className="modal-v2-step2-indicator-result is-error">
                                <span className="modal-v2-step2-indicator-symbol">×</span>
                            </span>
                            <span className="modal-v2-step2-indicator-line" />
                            <span className="modal-v2-step2-indicator-dot" />
                        </div>
                        <div className="modal-v2-step2-status-text is-error">Not Successfully Connected</div>
                    </>
                ) : (
                    <div className="modal-v2-step2-idle-row">
                        <span className="modal-v2-step2-indicator-dot is-idle" />
                        <div className="modal-v2-step2-status-text is-idle">Ready to test connection</div>
                    </div>
                )}
            </div>

            <div className="modal-v2-step2-actions">
                <button
                    type="button"
                    className={`btn modal-v2-btn modal-v2-btn-primary modal-v2-step2-test-btn ${load ? "disabled" : ""}`}
                    onClick={disabled ? null : () => onButtonClick()}
                    disabled={disabled || load}
                >
                    {load && <span className="modal-v2-step2-button-loader" />}
                    <span>{load ? "Testing..." : "Check Connectivity"}</span>
                </button>
            </div>

            {errorMessage &&
                <div className="modal-v2-step2-error-box">
                    <div className="modal-v2-step2-error-message">
                        {errorMessage}
                        {errorMessage.includes("401") && " (Invalid credentials)"}
                    </div>
                </div>
            }
        </div>
    )

}

export default CheckConnectionSection;
